import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";

const Footer = ({ isDisabled }) => {
  return (
    <footer
      style={{
        ...footerStyle,
        pointerEvents: isDisabled ? "none" : "auto",
      }}
    >
      <div style={footerContentStyle}>
        <div style={brandingStyle}>
          <p style={textStyle}>Developed By Ariel Davies</p>
        </div>
        <div style={socialLinksStyle}>
          <a
            href="https://github.com/ariellio"
            target="_blank"
            rel="noopener noreferrer"
            style={socialIconStyle}
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/arieldavies/"
            target="_blank"
            rel="noopener noreferrer"
            style={socialIconStyle}
          >
            <FaLinkedin />
          </a>
        </div>
      </div>
    </footer>
  );
};

const footerStyle = {
  backgroundColor: "#283593",
  color: "#ffffff",
  textAlign: "center",
  padding: "10px 20px",
  position: "fixed",
  width: "100%",
  bottom: 0,
  fontFamily: "Arial, sans-serif",
};

const footerContentStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  gap: "20px",
};

const brandingStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const textStyle = {
  fontSize: "14px",
  margin: "0",
};

const socialLinksStyle = {
  display: "flex",
  gap: "15px",
};

const socialIconStyle = {
  fontSize: "20px",
  color: "#fff",
  transition: "color 0.3s ease",
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

socialIconStyle[":hover"] = {
  color: "#61DAFB", // React theme color for hover effect
};

export default Footer;
